import { useCallback, useEffect, useState } from "react";

export const DAY_MODE_MS = 2 * 60 * 1000; // TV safety: a forgotten day/range filter returns to the live board

// Drill-down state: `panelRange` = {from,to} open in the detail panel, `boardRange` = range the whole board is filtered to
export function useDayMode() {
  const [panelRange, setPanelRange] = useState(null);
  const [boardRange, setBoardRange] = useState(null);

  useEffect(() => {
    if (!boardRange) return undefined;
    const t = setTimeout(() => setBoardRange(null), DAY_MODE_MS);
    return () => clearTimeout(t);
  }, [boardRange]);

  const showOnBoard = useCallback((range) => {
    setBoardRange(range);
    setPanelRange(null);
  }, []);
  const exitBoard = useCallback(() => setBoardRange(null), []);
  return { panelRange, setPanelRange, boardRange, showOnBoard, exitBoard };
}
